import { z } from "zod";

const SquareConnectionSchema = z.object({
  status: z.enum(["disconnected", "connected", "reconnect_required"]),
  environment: z.enum(["sandbox", "production"]),
  merchant: z.object({
    id: z.string(),
    businessName: z.string().nullable(),
    country: z.string(),
    currency: z.string(),
  }).nullable(),
});

const SquareConnectionDtoSchema = z.object({
  status: SquareConnectionSchema.shape.status,
  environment: SquareConnectionSchema.shape.environment,
  merchant: z.object({
    id: z.string(),
    business_name: z.string().nullable(),
    country: z.string(),
    currency: z.string(),
  }).nullable(),
});

export const SquareConnectDtoSchema = z.object({
  attempt_id: z.uuid(),
  browser_verifier: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
  location_id: z.string().min(1),
});
export const SquareCompleteDtoSchema = SquareConnectDtoSchema.omit({ location_id: true }).extend({
  completion_token: z.string().min(1),
});

export type SquareConnectionDto = z.infer<typeof SquareConnectionDtoSchema>;
export type SquareConnectDto = z.infer<typeof SquareConnectDtoSchema>;
export type SquareCompleteDto = z.infer<typeof SquareCompleteDtoSchema>;
export type SquareConnection = z.infer<typeof SquareConnectionSchema>;

export function fromSquareConnectionDtoToSquareConnection(dto: SquareConnectionDto): SquareConnection {
  const parsed = SquareConnectionDtoSchema.parse(dto);
  return {
    status: parsed.status,
    environment: parsed.environment,
    merchant: parsed.merchant ? {
      id: parsed.merchant.id,
      businessName: parsed.merchant.business_name,
      country: parsed.merchant.country,
      currency: parsed.merchant.currency,
    } : null,
  };
}
